import { Navigate } from "react-router-dom";
import { routes } from "../utils";
import {
  AddEditBillingCategory,
  AddEditBlock,
  AddEditCategory,
  AddEditIncidentCategory,
  AddEditIncidentType,
  AddEditInsuranceType,
  AddEditModel,
  AddEditPaymentMethod,
  AddEditPaymentTerm,
  AddEditZone,
  BillingCategory,
  IncidentCategory,
  IncidentType,
  InsuranceType,
  PaymentMethod,
  PaymentTerm,
  PropertyBlock,
  PropertyCategory,
  PropertyModel,
  PropertyZone,
  Properties,
  AddEditProperty,
  CamAddEditBudget,
  CamAddEditLineItem,
  CamBudgetMgmt,
  PropertyBulkUpload,
  GLSetup,
  CamLineItems,
  MasterDataOwners,
  MasterDataOwnerDetails,
  MasterDataCreateOwner,
  MasterDataPropertyOwnership,
  MasterDataOwnershipDetail,
  MasterDataNewOwnership,
  AddEditOwner,
  Announcements,
  OwnerBulkUpload,
  OwnerBulkUploadHistory,
  OwnerBulkUploadDetail,
  CamAddEditVendor,
  CamVendorMgmt,
  CamDocumentTypeConfig,
  CamAddEditConfig,
  OwnersReport,
  PropertyReport,
} from "@/pages";
import { PermissionGuard } from "@/components";
import { actionsKeys } from "@/lib/utils";

export const MasterDataRoutes = () => {
  return {
    path: routes.masterData,
    children: [
      {
        path: "",
        element: (
          <Navigate
            to={`/${routes.cam}/${routes.masterData}/${routes.propertyCategory}`}
          />
        ),
      },
      {
        path: routes.propertyCategory,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PropertyCategory />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditCategory />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditCategory />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.propertyModel,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PropertyModel />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditModel />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditModel />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.propertyZone,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PropertyZone />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditZone />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditZone />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.propertyBlock,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PropertyBlock />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditBlock />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.zoneId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditBlock />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.documentTypeConfig,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.DOCUMENT_TYPE}>
                <CamDocumentTypeConfig />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.DOCUMENT_TYPE} action={routes.add}>
                <CamAddEditConfig />
              </PermissionGuard>
          },
          {
            path: routes.documentTypeId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.DOCUMENT_TYPE}>
                <CamAddEditConfig />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.insuranceType,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <InsuranceType />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditInsuranceType />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditInsuranceType />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.paymentMethod,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PaymentMethod />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditPaymentMethod />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditPaymentMethod />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.paymentTerm,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PaymentTerm />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditPaymentTerm />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditPaymentTerm />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.billingCategory,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <BillingCategory />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditBillingCategory />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditBillingCategory />
              </PermissionGuard>
          },
        ]
      },
      {
        path: routes.budgetMgmt,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
                <CamBudgetMgmt />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.BUDGET} action={routes.add}>
                <CamAddEditBudget />
              </PermissionGuard>
          },
          {
            path: routes.budgetId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
                <CamAddEditBudget />
              </PermissionGuard>
          },
          {
            path: routes.budgetId + "/" + routes.lineItems,
            element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
                <CamLineItems />
              </PermissionGuard>
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.BUDGET} action={routes.add}>
                <CamAddEditLineItem />
              </PermissionGuard>
          },
          {
            path:
              routes.budgetId +
              "/" +
              routes.lineItems +
              "/" +
              routes.lineItemId +
              "/" +
              routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.BUDGET}>
                <CamAddEditLineItem />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.incidentType,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <IncidentType />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditIncidentType />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditIncidentType />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.incidentCategory,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <IncidentCategory />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditIncidentCategory />
              </PermissionGuard>
          },
          {
            path: routes.id + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditIncidentCategory />
              </PermissionGuard>
          },
        ],
      },
      {
        path: routes.propertyOwnership,
        children: [
          { path: "", element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}><MasterDataPropertyOwnership /></PermissionGuard> },
          { path: routes.newOwnership, element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}><MasterDataNewOwnership /></PermissionGuard> },
          { path: routes.id, element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}><MasterDataOwnershipDetail /></PermissionGuard> },
        ],
      },
      {
        path: routes.owner,
        children: [
          {
            path: routes.createOwner,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}><MasterDataCreateOwner /></PermissionGuard>
          },
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <MasterDataOwners />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditOwner />
              </PermissionGuard>
          },
          {
            path: routes.details + "/" + routes.userId,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <MasterDataOwnerDetails />
              </PermissionGuard>
          },
          {
            path: routes.userId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditOwner />
              </PermissionGuard>
          },
          {
            path: routes.bulkUpload,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <OwnerBulkUpload />
              </PermissionGuard>
          },
          {
            path: routes.uploadHistory,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <OwnerBulkUploadHistory />
              </PermissionGuard>
          },
          {
            path: routes.uploadHistory + "/" + routes.attachmentId,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <OwnerBulkUploadDetail />
              </PermissionGuard>
          }
        ]
      },
      {
        path: routes.vendorMgmt,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <CamVendorMgmt />
              </PermissionGuard>
          },
          {
            path: routes.add,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <CamAddEditVendor />
              </PermissionGuard>
          },
          {
            path: routes.vendorId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <CamAddEditVendor />
              </PermissionGuard>
          }
        ]
      },
      {
        path: routes.properties,
        children: [
          {
            path: "",
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <Properties />
              </PermissionGuard>
          },
          {
            path: routes.add, 
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA} action={routes.add}>
                <AddEditProperty />
              </PermissionGuard>
          },
          {
            path: routes.propertyId + "/" + routes.action,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <AddEditProperty />
              </PermissionGuard>
          },
          {
            path: routes.bulkUpload,
            element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
                <PropertyBulkUpload />
              </PermissionGuard>
          }
        ]
      },
      {
        path: routes.glSetup,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <GLSetup />
          </PermissionGuard>
      },
      {
        path: routes.announcement,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <Announcements />
          </PermissionGuard>
      },
      {
        path: routes.ownerReport,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <OwnersReport />
          </PermissionGuard>
      },
      {
        path: routes.propertyReport,
        element: <PermissionGuard moduleKey={actionsKeys?.MASTER_DATA}>
            <PropertyReport />
          </PermissionGuard>
      },
    ],
  };
};
